import { Spin } from 'antd';

export default ({ height }) => (
  <div className="loading-screen" style={{ minHeight: `${height}` }}>
    <Spin size="large" style={{ marginTop: 20 }} />
  </div>
);
